import { render, staticRenderFns } from "./ColumnDialog.vue?vue&type=template&id=ddd36348&"
import script from "./ColumnDialog.vue?vue&type=script&lang=js&"
export * from "./ColumnDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports